/** @jsx jsx  */
import React, { memo } from "react";
import { SerializedStyles, jsx } from "@emotion/core";

export interface IWithStylesProps
    extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement> {
    as?: React.ElementType;
    elRef?: React.RefObject<any>;
    cssProps: SerializedStyles | SerializedStyles[] | React.CSSProperties;
}

function WithStylesVoidElement({
    as = "div",
    cssProps,
    children,
    elRef,
    ...props
}: IWithStylesProps) {
    const Component = as;

    return <Component css={cssProps} ref={elRef} {...props} />;
}

export default memo(WithStylesVoidElement);
